import styled, { css } from 'styled-components'

import { BREAK_POINT_MD, BREAK_POINT_LG } from '@CSSVars/variables'
import { LINK_COLOR, ERROR_COLOR, OUTLINE_COLOR, TEXT_GREY } from '@CSSVars/colors'
import ArchiveListingInfo from '../ArchiveListingInfo'

const _FontCSS = css`
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
`

export const _ArchiveListingInfoDesktop = styled(ArchiveListingInfo)`
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: none;
  }
`

export const _ArchiveListingInfoMobile = styled(ArchiveListingInfo)`
  display: none;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: flex;
  }
`

export const _Location = styled.span`
  line-height: 22px;
  font-size: 14px;
  font-weight: 600;
`

export const _DaysOnMarket = styled.div`
  ${_FontCSS};
  color: ${TEXT_GREY};

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: none !important;
  }
`
// export const listingDetailContainerMobileCss = css`
//   display: none;
//   @media screen and (max-width: ${BREAK_POINT_MD}) {
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//     width: 100%;
//     > div {
//       width: 100%;
//     }
//   }
//
// `
// export const listingDetailContainerCss = css`
//   flex-direction: row;
//   justify-content: center;
//   @media screen and (max-width: ${BREAK_POINT_MD}) {
//     display: none;
//   }
//
// `
export const _ListingDetailContainer = styled.div`
  display: flex;
  align-items: flex-end;
  flex-grow: 1;
  padding-left: 16px;

  > div {
    line-height: 22px;
  }
  ${({ isHiddenOnPrint }) => (isHiddenOnPrint && `
    opacity: 0.4;
  `)};

  @media screen and (max-width: 1280px) {
    align-items: ${({ listingPage }) => (listingPage ? 'flex-end' : 'flex-start')};
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    align-items: flex-start;
  }

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: block;
  }
`

export const _UnitInformationContainer = styled.div`
  width: 230px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  border-right: 1px solid ${OUTLINE_COLOR};
  margin-right: 24px;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    margin-right: 0;
    margin-bottom: 2px;
    border-right: none;
  }
`

export const _Date = styled.div`
  line-height: 22px;
  font-size: 14px;
`

export const _AllHiddenMessage = styled.div`
  height: 100%;
  justify-content: flex-end;
  padding: 0 10px;
  div {
    line-height: 21px;
  }
  span {
    color: ${LINK_COLOR} !important;
  }

  @media screen and (min-width: ${BREAK_POINT_MD}) {
    display: flex;
    align-items: center;
    height: 100%;
  }

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    margin-top: 4px;
    padding: 0;
  }
`


export const _DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 20%;
  padding: 0 10px;
  flex-shrink: 0;
  margin-bottom: 2px;
  div {
    ${_FontCSS}
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    padding: 0;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
  }

  ${({ listingPage }) => (listingPage ? `
    div {
      line-height: 24px;
    }
    ` : '')}
`

export const _DateDistance = styled.div`
  display: flex;
  flex-direction: column;
  ${_FontCSS};
  color: ${TEXT_GREY};
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: none;
  }
`
export const _StatusContainer = styled.div`
  width: 35%;
  display: flex;
  flex-direction: column;
  padding: 0 10px 0 20px;
  &:hover {
    cursor: pointer;
  }

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    width: 100%;
    padding: 0;
    margin-bottom: 6px;
    ${_DaysOnMarket} {
      display: inline-flex;
      >div, span {
        font-size: inherit;
        color: inherit;
        line-height: inherit;
      }
    }
  }

  @media screen and (min-width: ${BREAK_POINT_LG}) {
    ${_DaysOnMarket} {
      display: none;
    }
  }

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    padding: 0;
    margin-bottom: 6px;
  }

  ${({ listingPage }) => (listingPage ? `
    width: 45%;
    ` : '')}
`

export const _Status = styled.div`
  display: inline-flex;
  &, span, div {
    color: ${ERROR_COLOR};
    font-weight: 600;
    line-height: 22px;
  }

  ${({ underline }) => (underline ? `
   :hover{
      text-decoration: underline;
   }
    ` : '')}


`

export const _DaysOnMarketContainer = styled.div`
  padding-left: 24px;
  display: flex;
  align-items: end;
  border-left: 1px solid ${OUTLINE_COLOR};
  ${_DaysOnMarket}{
    display: inline-flex;
    div, span {
      font-size: inherit;
      color: ${TEXT_GREY};
      line-height: inherit;
    }
  }

  ${({ listingPage }) => (listingPage ? `
   @media screen and (max-width: ${BREAK_POINT_LG}) {
    display: none;
  }

    ` : `
     @media screen and (max-width: 1280px) {
    display: none;
  }

    `)}
  `

export const _ListedInfo = styled.div`
  &,div {
    line-height: 24px;
    color: ${TEXT_GREY};
  }
  display: inline-flex;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    &,div {
      font-size: 12px;
    }
  }
`

export const _PricePerSqft = styled.div`
  font-size: 12px;
  line-height: 18px;
  color: ${ERROR_COLOR};
  display: inline-flex;
  @media screen and (max-width: 600px) {
    display: none;
  }
`
